/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/above_the_line_medium'
export default icon
